module.exports = __webpack_public_path__ + "media/application/images/svgs/target-c9862aad11ff9e8250f5c2246117ec02.svg";